import { render, staticRenderFns } from "./assetsTabs.vue?vue&type=template&id=5f26e902"
import script from "./assetsTabs.vue?vue&type=script&lang=js"
export * from "./assetsTabs.vue?vue&type=script&lang=js"
import style0 from "./assetsTabs.vue?vue&type=style&index=0&id=5f26e902&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports